import React from 'react';

export const PricingTiers = ({dispatch}) => {
  const priceTiers = [
    {
      title: 'Gäste-WC',
      price: 'ab 6.000 Euro*',
      image: './page_images/basic.jpg',
      features: [
        'Stilvolles Design trifft auf Funktionalität.',
        'Eine kompakte Lösung für den kleinen Raum.',
        'Modern und platzsparend mit hochwertigen Basisarmaturen.'
      ]
    },
    {
      title: 'Kompakt',
      price: 'ab 15.000 Euro*',
      image: './page_images/dusche_badewanne.jpg',
      features: [
        'Clevere Raumgestaltung für kleinere Bäder.',
        'Durchdachte Lösungen bieten Komfort und Design zu einem attraktiven Preis.',
        'praktisch, elegant und zeitlos.'
      ]
    },
    {
      title: 'Komfort',
      price: 'ab 25.000 Euro*',
      image: './page_images/komfort.jpg',
      features: [
        'Annehmlichkeiten wie Fußbodenheizung, Dusch-WC oder Design-Armaturen.',
        'Hochwertige Materialien und innovative Technik.',
        'maximaler Komfort'
      ]
    },
    {
      title: 'Premium',
      price: 'ab 30.000 Euro*',
      image: './page_images/luxus.jpg',
      features: [
        'Exklusiver Luxus auf höchstem Niveau.',
        'Freistehende Badewanne, XXL-Dusche, Whirlpool, Sauna oder Sunshower sind nur einige der Beispiele, wie Ihr Bad zum privaten Wellness-Spa wird.',
        'Genießen Sie einzigartige Qualität und individuelles Design.'
      ]
    }
  ];

  return (
    <div className="pricingTiers">
      <h2 className="pricingTiersTitle">Traumbäder - Qualität in jeder Preisklasse</h2>
      <p className="pricingTiersSubtitle">* Alle angegebenen Preise verstehen sich inklusive Handwerkerleistungen.</p>
      
      <div className="pricingTiersGrid">
        {priceTiers.map((tier, index) => (
          <div className="pricingTier" key={index}>
            <div className="pricingTierImageWrapper">
              <img src={tier.image} alt={tier.title} className="pricingTierImage" />
            </div>
            <h3 className="pricingTierTitle">{tier.title}</h3>
            <ul className="pricingTierFeatures">
              {tier.features.map((feature, idx) => (
                <li key={idx}>{feature}</li>
              ))}
            </ul>
            <p className="pricingTierPrice">{tier.price}</p>
          </div>
        ))}
      </div>

      <div className="pricingTiersFooter">
        <p>
          Für die von Ihnen gewünschte Badausstattung können Sie ungefähr die oben genannten Kosten einplanen. 
          In der Regel setzt sich der Gesamtpreis für ein neues Badezimmer zu einem Drittel aus Material- und 
          zu zwei Dritteln aus den Arbeitskosten zusammen.
          <br/><br/>
          Nehmen Sie gerne über den untenstehenden Link Kontakt zu uns auf, damit wir in einem persönlichen 
          Gespräch weitere Fragen klären können!
        </p>
      </div>

      <div className="buttonWrapper">
        <button
          onClick={() => {
            dispatch({type: 'GO_TO_FORM'});
          }}
          className="button col-xs-12 col-sm-3 col-md-3"
        >
          Zum Kontaktformular
        </button>
      </div>
    </div>
  );
};

